import { css } from '@emotion/react'

export const overrideTableWrapperStyles = css`
  border-right: 1px solid #eee;
  border-left: 1px solid #eee;
  height: auto;
`

export const overrideRootStyles = css`
  padding: 0 25px 25px;
`

export const cellPropStyle = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const tableRowStyle = css`
  cursor: pointer;
  max-width: 100%;
  overflow: hidden;
  background-color: #f9f9f9;

  &.-is-alt-row {
    background-color: #fff;
  }
`

export const overrideTableLoader = css`
  border-right: 1px solid #eee;
  border-left: 1px solid #eee;
`
